import "./OrderFormPhone.scss";
import { useCallback, useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { NotificationManager } from "react-notifications";
import { useLangContext } from "../../context/languageContext";
import { useParams } from "react-router-dom";
import {
    postInquiry,
    getPricingPhoneCountries,
    getPricingPhoneAreasById,
    getPricingPhoneFeaturesById,
    getPageContent
} from "../../api/apiRequest";
import DefaultIcon from "../../assets/images/block 1.svg";
import SmllTick from "../../assets/images/SmllTick.svg";
import RedCross from "../../assets/images/RedCross.svg";
import { Tag } from "../../utils/GTMPageTag";

const today = new Date()
const year = today.getFullYear() 
const month = (today.getMonth() + 1 < 10 ? "0"+ (today.getMonth() + 1) : today.getMonth() + 1 )
const day = (today.getDate() + 1 < 10 ? "0"+ (today.getDate()) : today.getDate() )
const todayFormatted = year + '-' + month + '-' + day

const OrderFormPhone = (props) => {
    Tag("OrderFormPhone")
    const { hostLanguage, languageJson } = useLangContext();
    const navigateLink = props.navigateLink ?? '/Order/Phone';
    const { country, area } = useParams();
    //API
    const getAllCountries = async () => {
        try {
            let apiRes = await getPricingPhoneCountries();
            let responseData = await apiRes.json();
            if (responseData.res) {
                const countriesArray = Object.values(responseData.data).flat(); //Object to Array Conversation
                setCountries(countriesArray);
            } else {
                NotificationManager.error(responseData.msg, "", 2000);
            }
        } catch (error) {
            // NotificationManager.error('Something went wrong!', '',2000);
        }
    };
    const getAllAreas = async (country) => {
        try {
            let apiRes = await getPricingPhoneAreasById(country);
            let responseData = await apiRes.json();
            if (responseData.res) {
                const areasArray = Object.values(responseData.data).flat(); //Object to Array Conversation
                setAreas(areasArray);
            } else {
                NotificationManager.error(responseData.msg, "", 2000);
            }
        } catch (error) {
            // NotificationManager.error('Something went wrong!', '',2000);
        }
    };
    const getAllAreaFeaturesByCountry = useCallback(async (country_id) => {
        try {
            let apiRes = await getPricingPhoneFeaturesById(country_id, hostLanguage);
            let responseData = await apiRes.json();
            if (responseData.res) {
                setFeatures(responseData.data);
            } else {
                setFeatures([])
            }
        } catch (error) {
          // NotificationManager.error('Something went wrong!', '',2000);
        }
    }, [hostLanguage]);

    const sendInquire = async () => {
        let countryName = countries.find(item => item.id === parseInt(countryUsed))?.name;
        let areaName = areas.find(item => item.id === parseInt(areaUsed))?.area_text;
        let paymentPlanName = paymentPlans.find(item => item.title === paymentPlan)?.title;

        let formData = {
            "type": "phone",
            "lang": hostLanguage,
            //Customer Details
            "customer": {
                "company": customerCompany,
                "name": customerName,
                "street": customerStreet,
                "postcode_city": customerCity,
                "country": customerCountry,
                "phone": customerPhone,
                "email": customerMail,
                "message": customerMessage
            },
            //Product Details
            "product": {
                "country": countryName,
                "areaName": areaName,
                "contract_duration": contractDuration,
                "starting": starting
            },
            //Payment Details
            "payment": {
                "paymentPlanName": paymentPlanName,
                "payment_method": paymentMethod,
                "gross": base.toFixed(2),
                "tax": 0,
                "net": 0,
                "tax_rate": 0
            }
        };

        if( customerName === "" || customerMail === "" || customerPhone === "" ){
            NotificationManager.error(contentDetails?.pricing_mail_box_page_data_inquiry_phone?.requiredFieldsMissing, "", 10000);
            return;
        }
    
        let apiRes = await postInquiry(formData);
        let responseData = await apiRes.json();
        if (responseData.res) {
            NotificationManager.success(responseData.msg, "", 2000);
            window.location.href = '/danke';
        }else{
            NotificationManager.error(responseData.msg, "", 2000);
        }
    };

    //Country
    const [countries, setCountries] = useState([]);
    const [countryUsed, setCountry] = useState(country ?? "");
    useEffect(() => {
        getAllAreas(countryUsed);
        if(countryUsed !== undefined && countryUsed !== ""){
            if(area !== undefined && area !== ""){
                window.history.pushState({}, null, navigateLink+'/'+countryUsed+'/'+area);
            }else{
                window.history.pushState({}, null, navigateLink+'/'+countryUsed);
            }
        }
        setArea("");
    }, [countryUsed, area, navigateLink]);

    //All country based Areas
    const [areas, setAreas] = useState([]);
    useEffect(() => {
        let durations = [...new Set(areas.map(item => item.contract))];
        setContractDurations(durations);
        if(durations.length>0){
            setContractDuration(durations[0])
        }
    }, [areas]);

    //Duration
    const [contractDurations, setContractDurations] = useState([]);
    const [contractDuration, setContractDuration] = useState(null); 

    //All country and duration based Areas
    const [filteredAreas, setFilteredAreas] = useState([]);
    const [areaUsed, setArea] = useState("");

    useEffect(() => {
        let filteredPlans = areas.filter(item => item.contract === contractDuration);
        if(filteredPlans !== undefined){
            setFilteredAreas(filteredPlans);
            if(filteredPlans.length>0){
                if(area !== undefined){
                    if(filteredPlans.find(item => item.id === parseInt(area)) === undefined){
                        setArea(filteredPlans[0].id)
                    }else{
                        setArea(area);
                    }
                }else{
                    setArea(filteredPlans[0].id)
                }
            }
            
        }
    },[contractDuration, areas, area]);

    //Payment Plan
    const [paymentPlan, setPaymentPlan] = useState("");

    //Save selected plan
    const [selectedPlan, setSelectedPlan] = useState("");
    useEffect(() => {
        setSelectedPlan(areas.find(item => item.id === parseInt(areaUsed)))      
        getAllAreaFeaturesByCountry(countryUsed)
        if(areaUsed !== ""){
            window.history.pushState({}, null, navigateLink+'/'+countryUsed+'/'+areaUsed);
        }
    }, [areaUsed, areas, countryUsed, getAllAreaFeaturesByCountry, navigateLink]);
    const [features, setFeatures] = useState([]);



    const [base, setBase] = useState(0);
    const [setup, setSetup] = useState(0);
    const [speaking, setSpeaking] = useState(0);
    const [starting, setStarting] = useState(todayFormatted);
    const [paymentMethod, setPaymentMethod] = useState("");

    const [customerCompany, setCustomerCompany] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [customerStreet, setCustomerStreet] = useState("");
    const [customerCity, setCustomerCity] = useState("");
    const [customerCountry, setCustomerCountry] = useState("");
    const [customerPhone, setCustomerPhone] = useState("");
    const [customerMail, setCustomerMail] = useState("");
    const [customerMessage, setCustomerMessage] = useState("");

    const [paymentPlans, setPaymentPlans] = useState([]);

    useEffect(() => {
        let divideBy = paymentPlans.find(item => item.title === paymentPlan)?.divideBy

        if( divideBy === 1 ){
            setBase( parseFloat(selectedPlan?.monthly_fee) * 12 - parseFloat(selectedPlan?.monthly_fee) )
        }else{
            setBase( parseFloat(selectedPlan?.monthly_fee) )
        }

        setSetup( parseFloat(selectedPlan?.setup_charges) )

        setSpeaking( parseFloat(selectedPlan?.talking_fee) )
    },[contractDuration, areaUsed, paymentPlans, paymentPlan, paymentMethod, selectedPlan]);

    //PAGE INIT
    const [contentDetails, setContentDetails] = useState();
    const getAllPageContent = useCallback(async () => {
        try {
            let apiRes = await getPageContent(hostLanguage, "pricing_mail_box_page_data_inquiry_phone");
            let responseData = await apiRes.json();
            if (responseData.res) {
                setContentDetails(responseData.data);

                setPaymentMethod(responseData.data?.pricing_mail_box_page_data_inquiry_phone?.invoice)
                setPaymentPlans([
                    {
                        title: responseData.data?.pricing_mail_box_page_data_inquiry_phone?.payment_plan_upfront,
                        divideBy: 1
                    },
                    {
                        title: responseData.data?.pricing_mail_box_page_data_inquiry_phone?.payment_plan_monthly,
                        divideBy: 12,
                        default: 1
                    }
                ])
                
            } else {
                NotificationManager.error(responseData.msg, "", 2000);
            }
        } catch (error) {
            console.error(error);
        }
    }, [hostLanguage]);

    useEffect(() => {
        setPaymentPlan(paymentPlans.find(item => item.default === 1)?.title)
    }, [paymentPlans]);

    useEffect(() => {
        getAllPageContent();
        getAllCountries();
    }, [hostLanguage, getAllPageContent]);
    return(
        <div id="OrderPhone" className="container">
            <div className="DigitalmailboxinLftCheckBox DigitalmailboxinLftCheckBox5 row">
                <div className="col-sm-12">
                    <Form.Select
                        value={countryUsed}
                        onChange={(e) => {setCountry(e.target.value)}}
                    >
                        <option value="" hidden>
                            {contentDetails?.pricing_mail_box_page_data_inquiry_phone?.tab_1_select_box_1_default_text}
                        </option>
                        {countries?.length > 0 ? (
                            countries?.map((item, idx) => {
                                return (
                                        <option key={idx} value={item?.id}>
                                            {item?.name}
                                        </option>
                                    );
                                })
                            ) : (
                            <option disabled>
                                {languageJson?.countryNotFound}
                            </option>
                            )
                        }
                    </Form.Select>
                </div>
            </div>
            {areas.length > 0 ?
                <div className="Content row">
                    <div className="LeftBox">
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.title_contractDuration}</h4>
                            <div >
                                {contractDurations.map((value, idx) => {
                                    return (
                                        <span key={idx} className="d-block col-12">
                                            <input 
                                                id={"contractDuration"+idx} 
                                                className="me-2"
                                                type="radio" 
                                                value={value} 
                                                checked={contractDuration === value}
                                                onChange={(e) => {setContractDuration(e.target.value)}}
                                            />
                                            <label htmlFor={"contractDuration"+idx}>{value} {contentDetails?.pricing_mail_box_page_data_inquiry_phone?.months}</label>
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.title_accountType}</h4>
                            <div >
                                {filteredAreas.map((value, idx) => {
                                    return (
                                        <span key={idx} className="d-block col-12 ">
                                            <input 
                                                id={"accountType"+idx} 
                                                className="me-2"
                                                type="radio" 
                                                value={value.id} 
                                                checked={parseInt(areaUsed) === value.id}
                                                onChange={(e) => {setArea(e.target.value)}}
                                            />
                                            <label htmlFor={"accountType"+idx}>{value.area_text}</label>
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.title_paymentPlan}</h4>
                            <div>
                                {paymentPlans.map((value, idx) => {
                                    return (
                                        <span key={idx} className="d-block col-12">
                                            <input 
                                                id={"paymentPlan"+idx} 
                                                className="me-2"
                                                type="radio" 
                                                value={value.title} 
                                                checked={paymentPlan === value.title}
                                                onChange={(e) => {setPaymentPlan(e.target.value)}}
                                            />
                                            <label htmlFor={"paymentPlan"+idx}>{value.title}</label>
                                        </span>
                                    );
                                })}
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.title_starting}</h4>
                            <div>
                                <input type="date" className="form-control" value={starting} onChange={(e) => {setStarting(e.target.value)}}/>
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.title_client}</h4>
                            <div>
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.input_companyName} value={customerCompany} onChange={(e) => setCustomerCompany(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.input_name} value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.input_street} value={customerStreet} onChange={(e) => setCustomerStreet(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.input_postcode_city} value={customerCity} onChange={(e) => setCustomerCity(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.input_country} value={customerCountry} onChange={(e) => setCustomerCountry(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.input_phone} value={customerPhone} onChange={(e) => setCustomerPhone(e.target.value)} />
                                <input type="text" className="form-control col-sm-12 mb-2" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.input_mail} value={customerMail} onChange={(e) => setCustomerMail(e.target.value)} />
                                <textarea rows="5" className="form-control col-sm-12" placeholder={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.input_message} value={customerMessage} onChange={(e) => setCustomerMessage(e.target.value)} ></textarea>
                            </div>
                        </div>
                        <div>
                            <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.title_paymentMethod}</h4>
                            <div>
                                <span className="d-block col-12">
                                    <input 
                                        id={"paymentMethod0"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.invoice} 
                                        checked={paymentMethod === contentDetails?.pricing_mail_box_page_data_inquiry_phone?.invoice}
                                        onChange={(e) => {setPaymentMethod(e.target.value)}}
                                    />
                                    <label htmlFor={"paymentMethod0"}>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.invoice}</label>
                                </span>
                                <span className="d-block col-12">
                                    <input 
                                        id={"paymentMethod1"} 
                                        className="me-2"
                                        type="radio" 
                                        value={contentDetails?.pricing_mail_box_page_data_inquiry_phone?.transfer} 
                                        checked={paymentMethod === contentDetails?.pricing_mail_box_page_data_inquiry_phone?.transfer}
                                        onChange={(e) => {setPaymentMethod(e.target.value)}}
                                    />
                                    <label htmlFor={"paymentMethod1"}>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.transfer}</label>
                                </span>
                            </div>
                        </div>
                    </div> 
                    <div className="RightBox">
                        <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.tab_2_tarifdetails} {contentDetails?.product_mail_page_data?.inkl_vat}</h4>
                        <ul>
                            <li className="d-flex flex-row justify-content-between">
                                <p>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.tab_2_tarifdetails_label_4}</p>
                                <span>{contractDuration ?? 0} {contentDetails?.pricing_mail_box_page_data_inquiry_phone?.tab_2_tarifdetails_label_4_after_value_text}</span>
                            </li>
                            <li className="d-flex flex-row justify-content-between">
                                <p>{contentDetails?.pricing_mail_box_page_data_inquiry_phone.tab_2_tarifdetails_label_1}</p>
                                <span>{Number(setup ?? 0).toFixed(2)} €</span>
                            </li>
                            <li className="d-flex flex-row justify-content-between">
                                <p>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.tab_2_tarifdetails_label_2}</p>
                                <span>{Number(base ?? 0).toFixed(2)} €</span>
                            </li>
                        </ul>
                        <hr />
                        <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.tab_2_features}</h4>
                        <ul>
                            <li className="d-flex flex-row justify-content-between">
                                <p>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.tab_2_tarifdetails_label_3}</p>
                                <span>{Number(speaking ?? 0).toFixed(2)} € {contentDetails?.pricing_mail_box_page_data_inquiry_phone?.tab_2_tarifdetails_label_3_after_value_text}</span>
                            </li>
                            {features?.map((item, index) => {
                            return (
                                <li key={index}>
                                {" "}
                                {item?.access_status === 0 ? (
                                    <img src={RedCross} alt="Img" />
                                ) : item?.access_status === 1 ? (
                                    <img src={SmllTick} alt="Img" />
                                ) : item?.access_status === 2 ? (
                                    <img src={DefaultIcon} alt="Img" />
                                ) : null}
                                {item?.feature}
                                </li>
                            );
                            })}
                        </ul>
                        <button onClick={sendInquire} className="btn btn-primary">{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.btn_send_inquiry}</button>
                    </div>
                </div>
            : 
                <div className="text-center">
                    <h4>{contentDetails?.pricing_mail_box_page_data_inquiry_phone?.noCountry}</h4>
                </div>
            }
        </div>
    );
};

export default OrderFormPhone;